export default "__VITE_ASSET__a7a58568__"